/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

import { styled } from '@mui/material';

import { SquareIconButton } from '../../../../../../Button/SquareIconButton/SquareIconButton';

export const StyledTowingsContainer = styled('div')`
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    justify-content: center;
`;

export const StyledTowingControls = styled('div')`
    margin-left: 10px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
`;

export const StyledSquareIconButton = styled(SquareIconButton)`
    background-color: #006ebb;
    height: 20px;
    width: 20px;
    border: none;

    &.MuiButtonBase-root.Mui-disabled {
        background-color: #006ebb !important;
        border-color: #006ebb !important;
        opacity: 0.3 !important;
    }

    &:hover {
        background-color: #006ebb !important;
    }
`;

export const StyledErrorContainer = styled('div')`
    position: absolute;
    bottom: 0;
    color: #db4343;
    font-size: 13px;
`;
